// extracted by mini-css-extract-plugin
export var phone = "_27-0";